var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.componentClasses,style:(_vm.componentStyles),on:{"click":function($event){return _vm.clicked()}}},[_c('header-simple',{staticClass:"gc-card-featured-image__header",attrs:{"headerText":_vm.header,"icon":'forward'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }